<template>
<div class="statauswahl">
  <select class="form-control" v-model="selected" @change="onChangeFire($event)">
     <option disabled value="">Bitte Saison auswählen</option>
     <option v-for="item in years" :value="item.id" :key="item.id">
     {{ item.saison }} 
     </option>
  </select>
</div>
    <div class="spielertablerespo">
    <table id="spielerstat" v-if="!fehlermeldung">
    <tr v-for="(data, index) in players" v-bind:key="index">
    <td v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']" class="tabname">{{ data.name }}</td>
    <td v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']">{{ data.spiele }}</td>
    <td v-if="data.minuten" v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']">{{ data.minuten }}</td>
    <td v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']">{{ increment(data.tore) }}</td>
    <td v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']">{{ increment(data.vorlagen) }}</td>
    <td v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']">{{ increment(data.punkte) }}</td>
    <td v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']">{{ increment(data.gelb) }}</td>
    <td v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']">{{ increment(data.gelbrot) }}</td>
    <td v-bind:class="[index %2 === 0 ? 'huhu' : 'haha']">{{ increment(data.rot) }}</td>
    </tr>
   </table>
   </div>
   <div v-if="fehlermeldung">Ein Fehler ist aufgetreten</div>
   <div v-if="!fehlermeldung">
   <br>
   <p>Die Statistik wurde von Josef Lorinser erstellt.</p>
   </div>
</template>

<script>
import axios from 'axios'

export default {

  name: 'App',
  data() {
    return {
            ueber: '',
            players: [],
            fehler: false,
            selected: '',
            fehlermeldung: '',
            years: [  
                {id: '22-23', saison: 'Saison 22-23'},
                {id: '21-22', saison: 'Saison 21-22'},
                {id: '20-21', saison: 'Saison 20-21'},
                {id: '19-20', saison: 'Saison 19-20'},
                {id: '18-19', saison: 'Saison 18-19'},
                {id: '17-18', saison: 'Saison 17-18'},
                {id: '16-17', saison: 'Saison 16-17'},
                {id: '15-16', saison: 'Saison 15-16'},
                {id: '14-15', saison: 'Saison 14-15'},
                {id: '13-14', saison: 'Saison 13-14'},
                {id: '12-13', saison: 'Saison 12-13'},
                {id: '11-12', saison: 'Saison 11-12'},
                {id: '10-11', saison: 'Saison 10-11'},
                {id: '09-10', saison: 'Saison 09-10'},
                {id: '08-09', saison: 'Saison 08-09'},
                {id: '07-08', saison: 'Saison 07-08'},
                {id: '06-07', saison: 'Saison 06-07'},
                {id: '05-06', saison: 'Saison 05-06'},
                {id: '04-05', saison: 'Saison 04-05'}, 
                {id: '03-04', saison: 'Saison 03-04'}, 
                {id: '02-03', saison: 'Saison 02-03'}, 
                {id: '01-02', saison: 'Saison 01-02'}, 
                {id: '00-01', saison: 'Saison 00-01'}, 
                {id: '99-00', saison: 'Saison 99-00'},         
                {id: '98-99', saison: 'Saison 98-99'},         
                {id: '97-98', saison: 'Saison 97-98'},         
                {id: '96-97', saison: 'Saison 96-97'},         
                {id: '95-96', saison: 'Saison 95-96'},                          
              ],
        };
  },

  created: function () {
   this.getApi();
   // console.log(this.players)
  },

  methods: {
    uri2() {
      let demo =  new URL(location.href).searchParams.get('saison')
      console.log(demo);
    }, 
    
    getApi: function () {
      let para =  new URL(location.href).searchParams.get('saison')
      let param = '';
      // console.log(/^[ez][0-9]{2}-[0-9]{2}$/.test(para)); // false
      if(/^[ez][0-9]{2}-[0-9]{2}$/.test(para)) {
        param = para.substring(1,6)
      } 
      // console.log(para)
      let url;
      if(param == '') {
        url = "https://api.sv-reute.de/v2/spielerstatistik/eins/22-23";
      } else {
        url = `https://api.sv-reute.de/v2/spielerstatistik/eins/${param}`;
      }
      // Simple GET request using axios
      axios.get(url)
      .then(response => { this.players = response.data })
      .catch((error) => {
        console.log(error);
        this.fehler = true;
        this.fehlermeldung = "Ein Fehler ist aufgetreten.";
      });
    },

    getData: function(data) {
      var app = this;
      app.fehlermeldung = '';
      axios.get(`https://api.sv-reute.de/v2/spielerstatistik/eins/${data}`)
      .then(response => { this.players = response.data })
      .catch (function(error) {
        console.log(error);
        app.fehler = true;
        app.players = '';
        app.fehlermeldung = "Ein Fehler ist aufgetreten.";
      })
    },

    increment(data) {
      // `this` will refer to the component instance
      if(data == "0") {
        return "-"
      } 
      return data;
      
      },

     onChangeFire(event) {
       // console.log("event " +event.target.value)
       this.getData(event.target.value)
       const ueber = document.getElementById("u1");
       ueber.innerHTML = "Spielerstatistik SV Reute I Saison "+this.saison(event.target.value);
       // location.href = '/aktive/spielerstatistikv2/?saison=e'+event.target.value;
      },

      saison(data) {
        return data.replace("-", "/");
      },
  },
  
}
</script>

<style>
#app {
  color: #2c3e50;
  font-size:12px;
}

.spielertablerespo {
  overflow-x:auto;
}

.statauswahl {
  margin-bottom: 20px;
}

#spielerstat {
  border-collapse:collapse;
  width:100%;
  max-width:700px;
  text-align: center;
  }

#spielerstat td, #spielerstat th {
  border:1px solid #ddd;
  padding:8px
  }

#spielerstat tr:nth-child(2n){
  background-color:#f2f2f2
  }

#spielerstat tr:hover { 
  background-color:#ddd
  }

#spielerstat th { 
  padding-top:12px; 
  padding-bottom:12px;
  text-align:left;
  background-color:#04aa6d;
  color:#fff
  }

#spielerstat tr:first-child { 
  padding-top:14px; 
  padding-bottom:14px; 
  text-align:center;
  background-color:#0090d3;
  color:#fff
  }

.tabname { 
  text-align:left
  }

</style>
